module.exports = __webpack_public_path__ + "img/Steor-Icons-09.7146e6c9.svg";